// AUTO-GENERATED — canonical country reference (ISO 3166-1). Generated 2026-06-13.
// Single source of truth for country data shared by the billing UI and backend.
// Replaces the legacy scattered lists: STRIPE_COUNTRIES / AUTHNET_COUNTRIES (backend)
// and ALL_COUNTRIES / SCA_COUNTRIES (frontend). Keep the .js and .ts copies in sync.
//
// STATIC reference only. The set of countries you are REGISTERED to charge B2C tax in
// is OPERATIONAL config (env VAT_REGISTERED_B2C_COUNTRIES), NOT stored here.
// gateway: EEA (EU-27 + NO/IS/LI) + UK + CH -> 'stripe' (SCA/PSD2 + GDPR transfer basis);
//          everything else -> 'authnet' (cheaper, GDPR n/a for non-EEA/UK data subjects).

export interface Country { code: string; name: string; }
export interface Subdivision { code: string; name: string; }
export type Gateway = 'stripe' | 'authnet';
export type TaxRegime =
  | 'none' | 'eu_vat' | 'uk_vat' | 'ch_vat' | 'no_vat'
  | 'ca_gst' | 'au_gst' | 'nz_gst' | 'other';
export interface CountryMeta {
  gateway: Gateway;
  sca: boolean;
  taxRegime: TaxRegime;
  zeroThresholdB2C: boolean;
  hasTaxId: boolean;
  postal: 'required' | 'optional' | 'none';
  hasSubdivisions: boolean;
}

export const COUNTRIES: Country[] = [
  { code: "AF", name: "Afghanistan" },
  { code: "AL", name: "Albania" },
  { code: "DZ", name: "Algeria" },
  { code: "AS", name: "American Samoa" },
  { code: "AD", name: "Andorra" },
  { code: "AO", name: "Angola" },
  { code: "AI", name: "Anguilla" },
  { code: "AQ", name: "Antarctica" },
  { code: "AG", name: "Antigua and Barbuda" },
  { code: "AR", name: "Argentina" },
  { code: "AM", name: "Armenia" },
  { code: "AW", name: "Aruba" },
  { code: "AU", name: "Australia" },
  { code: "AT", name: "Austria" },
  { code: "AZ", name: "Azerbaijan" },
  { code: "BS", name: "Bahamas" },
  { code: "BH", name: "Bahrain" },
  { code: "BD", name: "Bangladesh" },
  { code: "BB", name: "Barbados" },
  { code: "BY", name: "Belarus" },
  { code: "BE", name: "Belgium" },
  { code: "BZ", name: "Belize" },
  { code: "BJ", name: "Benin" },
  { code: "BM", name: "Bermuda" },
  { code: "BT", name: "Bhutan" },
  { code: "BO", name: "Bolivia" },
  { code: "BQ", name: "Bonaire, Sint Eustatius and Saba" },
  { code: "BA", name: "Bosnia and Herzegovina" },
  { code: "BW", name: "Botswana" },
  { code: "BV", name: "Bouvet Island" },
  { code: "BR", name: "Brazil" },
  { code: "IO", name: "British Indian Ocean Territory" },
  { code: "BN", name: "Brunei" },
  { code: "BG", name: "Bulgaria" },
  { code: "BF", name: "Burkina Faso" },
  { code: "BI", name: "Burundi" },
  { code: "KH", name: "Cambodia" },
  { code: "CM", name: "Cameroon" },
  { code: "CA", name: "Canada" },
  { code: "CV", name: "Cape Verde" },
  { code: "KY", name: "Cayman Islands" },
  { code: "CF", name: "Central African Republic" },
  { code: "TD", name: "Chad" },
  { code: "CL", name: "Chile" },
  { code: "CN", name: "China" },
  { code: "CX", name: "Christmas Island" },
  { code: "CC", name: "Cocos (Keeling) Islands" },
  { code: "CO", name: "Colombia" },
  { code: "KM", name: "Comoros" },
  { code: "CD", name: "Congo (DRC)" },
  { code: "CG", name: "Congo (Republic)" },
  { code: "CK", name: "Cook Islands" },
  { code: "CR", name: "Costa Rica" },
  { code: "HR", name: "Croatia" },
  { code: "CU", name: "Cuba" },
  { code: "CW", name: "Cura\u00e7ao" },
  { code: "CY", name: "Cyprus" },
  { code: "CZ", name: "Czechia" },
  { code: "CI", name: "C\u00f4te d'Ivoire" },
  { code: "DK", name: "Denmark" },
  { code: "DJ", name: "Djibouti" },
  { code: "DM", name: "Dominica" },
  { code: "DO", name: "Dominican Republic" },
  { code: "EC", name: "Ecuador" },
  { code: "EG", name: "Egypt" },
  { code: "SV", name: "El Salvador" },
  { code: "GQ", name: "Equatorial Guinea" },
  { code: "ER", name: "Eritrea" },
  { code: "EE", name: "Estonia" },
  { code: "SZ", name: "Eswatini" },
  { code: "ET", name: "Ethiopia" },
  { code: "FK", name: "Falkland Islands (Malvinas)" },
  { code: "FO", name: "Faroe Islands" },
  { code: "FJ", name: "Fiji" },
  { code: "FI", name: "Finland" },
  { code: "FR", name: "France" },
  { code: "GF", name: "French Guiana" },
  { code: "PF", name: "French Polynesia" },
  { code: "TF", name: "French Southern Territories" },
  { code: "GA", name: "Gabon" },
  { code: "GM", name: "Gambia" },
  { code: "GE", name: "Georgia" },
  { code: "DE", name: "Germany" },
  { code: "GH", name: "Ghana" },
  { code: "GI", name: "Gibraltar" },
  { code: "GR", name: "Greece" },
  { code: "GL", name: "Greenland" },
  { code: "GD", name: "Grenada" },
  { code: "GP", name: "Guadeloupe" },
  { code: "GU", name: "Guam" },
  { code: "GT", name: "Guatemala" },
  { code: "GG", name: "Guernsey" },
  { code: "GN", name: "Guinea" },
  { code: "GW", name: "Guinea-Bissau" },
  { code: "GY", name: "Guyana" },
  { code: "HT", name: "Haiti" },
  { code: "HM", name: "Heard Island and McDonald Islands" },
  { code: "VA", name: "Holy See (Vatican City State)" },
  { code: "HN", name: "Honduras" },
  { code: "HK", name: "Hong Kong" },
  { code: "HU", name: "Hungary" },
  { code: "IS", name: "Iceland" },
  { code: "IN", name: "India" },
  { code: "ID", name: "Indonesia" },
  { code: "IR", name: "Iran" },
  { code: "IQ", name: "Iraq" },
  { code: "IE", name: "Ireland" },
  { code: "IM", name: "Isle of Man" },
  { code: "IL", name: "Israel" },
  { code: "IT", name: "Italy" },
  { code: "JM", name: "Jamaica" },
  { code: "JP", name: "Japan" },
  { code: "JE", name: "Jersey" },
  { code: "JO", name: "Jordan" },
  { code: "KZ", name: "Kazakhstan" },
  { code: "KE", name: "Kenya" },
  { code: "KI", name: "Kiribati" },
  { code: "KW", name: "Kuwait" },
  { code: "KG", name: "Kyrgyzstan" },
  { code: "LA", name: "Laos" },
  { code: "LV", name: "Latvia" },
  { code: "LB", name: "Lebanon" },
  { code: "LS", name: "Lesotho" },
  { code: "LR", name: "Liberia" },
  { code: "LY", name: "Libya" },
  { code: "LI", name: "Liechtenstein" },
  { code: "LT", name: "Lithuania" },
  { code: "LU", name: "Luxembourg" },
  { code: "MO", name: "Macao" },
  { code: "MG", name: "Madagascar" },
  { code: "MW", name: "Malawi" },
  { code: "MY", name: "Malaysia" },
  { code: "MV", name: "Maldives" },
  { code: "ML", name: "Mali" },
  { code: "MT", name: "Malta" },
  { code: "MH", name: "Marshall Islands" },
  { code: "MQ", name: "Martinique" },
  { code: "MR", name: "Mauritania" },
  { code: "MU", name: "Mauritius" },
  { code: "YT", name: "Mayotte" },
  { code: "MX", name: "Mexico" },
  { code: "FM", name: "Micronesia" },
  { code: "MD", name: "Moldova" },
  { code: "MC", name: "Monaco" },
  { code: "MN", name: "Mongolia" },
  { code: "ME", name: "Montenegro" },
  { code: "MS", name: "Montserrat" },
  { code: "MA", name: "Morocco" },
  { code: "MZ", name: "Mozambique" },
  { code: "MM", name: "Myanmar" },
  { code: "NA", name: "Namibia" },
  { code: "NR", name: "Nauru" },
  { code: "NP", name: "Nepal" },
  { code: "NL", name: "Netherlands" },
  { code: "NC", name: "New Caledonia" },
  { code: "NZ", name: "New Zealand" },
  { code: "NI", name: "Nicaragua" },
  { code: "NE", name: "Niger" },
  { code: "NG", name: "Nigeria" },
  { code: "NU", name: "Niue" },
  { code: "NF", name: "Norfolk Island" },
  { code: "KP", name: "North Korea" },
  { code: "MK", name: "North Macedonia" },
  { code: "MP", name: "Northern Mariana Islands" },
  { code: "NO", name: "Norway" },
  { code: "OM", name: "Oman" },
  { code: "PK", name: "Pakistan" },
  { code: "PW", name: "Palau" },
  { code: "PS", name: "Palestine" },
  { code: "PA", name: "Panama" },
  { code: "PG", name: "Papua New Guinea" },
  { code: "PY", name: "Paraguay" },
  { code: "PE", name: "Peru" },
  { code: "PH", name: "Philippines" },
  { code: "PN", name: "Pitcairn" },
  { code: "PL", name: "Poland" },
  { code: "PT", name: "Portugal" },
  { code: "PR", name: "Puerto Rico" },
  { code: "QA", name: "Qatar" },
  { code: "RO", name: "Romania" },
  { code: "RU", name: "Russia" },
  { code: "RW", name: "Rwanda" },
  { code: "RE", name: "R\u00e9union" },
  { code: "BL", name: "Saint Barth\u00e9lemy" },
  { code: "SH", name: "Saint Helena, Ascension and Tristan da Cunha" },
  { code: "KN", name: "Saint Kitts and Nevis" },
  { code: "LC", name: "Saint Lucia" },
  { code: "MF", name: "Saint Martin (French part)" },
  { code: "PM", name: "Saint Pierre and Miquelon" },
  { code: "VC", name: "Saint Vincent and the Grenadines" },
  { code: "WS", name: "Samoa" },
  { code: "SM", name: "San Marino" },
  { code: "ST", name: "Sao Tome and Principe" },
  { code: "SA", name: "Saudi Arabia" },
  { code: "SN", name: "Senegal" },
  { code: "RS", name: "Serbia" },
  { code: "SC", name: "Seychelles" },
  { code: "SL", name: "Sierra Leone" },
  { code: "SG", name: "Singapore" },
  { code: "SX", name: "Sint Maarten (Dutch part)" },
  { code: "SK", name: "Slovakia" },
  { code: "SI", name: "Slovenia" },
  { code: "SB", name: "Solomon Islands" },
  { code: "SO", name: "Somalia" },
  { code: "ZA", name: "South Africa" },
  { code: "GS", name: "South Georgia and the South Sandwich Islands" },
  { code: "KR", name: "South Korea" },
  { code: "SS", name: "South Sudan" },
  { code: "ES", name: "Spain" },
  { code: "LK", name: "Sri Lanka" },
  { code: "SD", name: "Sudan" },
  { code: "SR", name: "Suriname" },
  { code: "SJ", name: "Svalbard and Jan Mayen" },
  { code: "SE", name: "Sweden" },
  { code: "CH", name: "Switzerland" },
  { code: "SY", name: "Syria" },
  { code: "TW", name: "Taiwan" },
  { code: "TJ", name: "Tajikistan" },
  { code: "TZ", name: "Tanzania" },
  { code: "TH", name: "Thailand" },
  { code: "TL", name: "Timor-Leste" },
  { code: "TG", name: "Togo" },
  { code: "TK", name: "Tokelau" },
  { code: "TO", name: "Tonga" },
  { code: "TT", name: "Trinidad and Tobago" },
  { code: "TN", name: "Tunisia" },
  { code: "TM", name: "Turkmenistan" },
  { code: "TC", name: "Turks and Caicos Islands" },
  { code: "TV", name: "Tuvalu" },
  { code: "TR", name: "T\u00fcrkiye" },
  { code: "UG", name: "Uganda" },
  { code: "UA", name: "Ukraine" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "GB", name: "United Kingdom" },
  { code: "US", name: "United States" },
  { code: "UM", name: "United States Minor Outlying Islands" },
  { code: "UY", name: "Uruguay" },
  { code: "UZ", name: "Uzbekistan" },
  { code: "VU", name: "Vanuatu" },
  { code: "VE", name: "Venezuela" },
  { code: "VN", name: "Vietnam" },
  { code: "VG", name: "Virgin Islands, British" },
  { code: "VI", name: "Virgin Islands, U.S." },
  { code: "WF", name: "Wallis and Futuna" },
  { code: "EH", name: "Western Sahara" },
  { code: "YE", name: "Yemen" },
  { code: "ZM", name: "Zambia" },
  { code: "ZW", name: "Zimbabwe" },
  { code: "AX", name: "\u00c5land Islands" }
];

export const SUBDIVISIONS: Record<string, Subdivision[]> = {
  US: [
    { code: "AL", name: "Alabama" },
    { code: "AK", name: "Alaska" },
    { code: "AZ", name: "Arizona" },
    { code: "AR", name: "Arkansas" },
    { code: "CA", name: "California" },
    { code: "CO", name: "Colorado" },
    { code: "CT", name: "Connecticut" },
    { code: "DE", name: "Delaware" },
    { code: "DC", name: "District of Columbia" },
    { code: "FL", name: "Florida" },
    { code: "GA", name: "Georgia" },
    { code: "HI", name: "Hawaii" },
    { code: "ID", name: "Idaho" },
    { code: "IL", name: "Illinois" },
    { code: "IN", name: "Indiana" },
    { code: "IA", name: "Iowa" },
    { code: "KS", name: "Kansas" },
    { code: "KY", name: "Kentucky" },
    { code: "LA", name: "Louisiana" },
    { code: "ME", name: "Maine" },
    { code: "MD", name: "Maryland" },
    { code: "MA", name: "Massachusetts" },
    { code: "MI", name: "Michigan" },
    { code: "MN", name: "Minnesota" },
    { code: "MS", name: "Mississippi" },
    { code: "MO", name: "Missouri" },
    { code: "MT", name: "Montana" },
    { code: "NE", name: "Nebraska" },
    { code: "NV", name: "Nevada" },
    { code: "NH", name: "New Hampshire" },
    { code: "NJ", name: "New Jersey" },
    { code: "NM", name: "New Mexico" },
    { code: "NY", name: "New York" },
    { code: "NC", name: "North Carolina" },
    { code: "ND", name: "North Dakota" },
    { code: "OH", name: "Ohio" },
    { code: "OK", name: "Oklahoma" },
    { code: "OR", name: "Oregon" },
    { code: "PA", name: "Pennsylvania" },
    { code: "RI", name: "Rhode Island" },
    { code: "SC", name: "South Carolina" },
    { code: "SD", name: "South Dakota" },
    { code: "TN", name: "Tennessee" },
    { code: "TX", name: "Texas" },
    { code: "UT", name: "Utah" },
    { code: "VT", name: "Vermont" },
    { code: "VA", name: "Virginia" },
    { code: "WA", name: "Washington" },
    { code: "WV", name: "West Virginia" },
    { code: "WI", name: "Wisconsin" },
    { code: "WY", name: "Wyoming" }
  ],
  CA: [
    { code: "AB", name: "Alberta" },
    { code: "BC", name: "British Columbia" },
    { code: "MB", name: "Manitoba" },
    { code: "NB", name: "New Brunswick" },
    { code: "NL", name: "Newfoundland and Labrador" },
    { code: "NT", name: "Northwest Territories" },
    { code: "NS", name: "Nova Scotia" },
    { code: "NU", name: "Nunavut" },
    { code: "ON", name: "Ontario" },
    { code: "PE", name: "Prince Edward Island" },
    { code: "QC", name: "Quebec" },
    { code: "SK", name: "Saskatchewan" },
    { code: "YT", name: "Yukon" }
  ],
  AU: [
    { code: "ACT", name: "Australian Capital Territory" },
    { code: "NSW", name: "New South Wales" },
    { code: "NT", name: "Northern Territory" },
    { code: "QLD", name: "Queensland" },
    { code: "SA", name: "South Australia" },
    { code: "TAS", name: "Tasmania" },
    { code: "VIC", name: "Victoria" },
    { code: "WA", name: "Western Australia" }
  ]
};

export const DEFAULT_META: CountryMeta = {"gateway": "authnet", "sca": false, "taxRegime": "other", "zeroThresholdB2C": false, "hasTaxId": false, "postal": "optional", "hasSubdivisions": false};

// Only countries that differ from DEFAULT_META are listed.
export const COUNTRY_META: Record<string, Partial<CountryMeta>> = {
  AT: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  AU: {"gateway": "authnet", "sca": false, "taxRegime": "au_gst", "zeroThresholdB2C": false, "hasTaxId": true, "postal": "required", "hasSubdivisions": true},
  BE: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  BG: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  CA: {"gateway": "authnet", "sca": false, "taxRegime": "ca_gst", "zeroThresholdB2C": false, "hasTaxId": true, "postal": "required", "hasSubdivisions": true},
  CH: {"gateway": "stripe", "sca": false, "taxRegime": "ch_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  CY: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  CZ: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  DE: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  DK: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  EE: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  ES: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  FI: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  FR: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  GB: {"gateway": "stripe", "sca": true, "taxRegime": "uk_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "required", "hasSubdivisions": false},
  GR: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  HR: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  HU: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  IE: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  IS: {"gateway": "stripe", "sca": true, "taxRegime": "other", "zeroThresholdB2C": false, "hasTaxId": false, "postal": "optional", "hasSubdivisions": false},
  IT: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  LI: {"gateway": "stripe", "sca": true, "taxRegime": "other", "zeroThresholdB2C": false, "hasTaxId": false, "postal": "optional", "hasSubdivisions": false},
  LT: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  LU: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  LV: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  MT: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  NL: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  NO: {"gateway": "stripe", "sca": true, "taxRegime": "no_vat", "zeroThresholdB2C": false, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  NZ: {"gateway": "authnet", "sca": false, "taxRegime": "nz_gst", "zeroThresholdB2C": false, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  PL: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  PT: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  RO: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  SE: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  SI: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  SK: {"gateway": "stripe", "sca": true, "taxRegime": "eu_vat", "zeroThresholdB2C": true, "hasTaxId": true, "postal": "optional", "hasSubdivisions": false},
  US: {"gateway": "authnet", "sca": false, "taxRegime": "none", "zeroThresholdB2C": false, "hasTaxId": false, "postal": "required", "hasSubdivisions": true}
};

export const STRIPE_SET: string[] = ["AT", "BE", "BG", "CH", "CY", "CZ", "DE", "DK", "EE", "ES", "FI", "FR", "GB", "GR", "HR", "HU", "IE", "IS", "IT", "LI", "LT", "LU", "LV", "MT", "NL", "NO", "PL", "PT", "RO", "SE", "SI", "SK"];

export const getCountryMeta = (code: string): CountryMeta =>
  ({ ...DEFAULT_META, ...(COUNTRY_META[code] || {}) });
export const gatewayFor = (code: string): Gateway => getCountryMeta(code).gateway;
export const isStripeCountry = (code: string): boolean => gatewayFor(code) === 'stripe';
export const getSubdivisions = (code: string): Subdivision[] | null => SUBDIVISIONS[code] || null;
export const postalRule = (code: string): CountryMeta['postal'] => getCountryMeta(code).postal;
export const showTaxIdField = (code: string): boolean => getCountryMeta(code).hasTaxId;
export const isValidCountry = (code: string): boolean => COUNTRIES.some((c) => c.code === code);

